import { createSlice } from "@reduxjs/toolkit";

const initialTeacherCoursesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  teachersWithBranches: [],
  sectionAndCourseIds: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const teacherCourseSlice = createSlice({
  name: "teacherCourses",
  initialState: initialTeacherCoursesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getTeacherCourses
    coursesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getTeacherWithBranches
    teachersWithBranchesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.teachersWithBranches = entities;
    },
    // getSectionsAndCourses
    sectionsAndCoursesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // getGradeLevelSectionAndCourses
    listFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections =  entity.sections;
      state.gradeLevels = entity.gradeLevels;
      state.courses =  entity.courses;
    },
    // getAllList
    allListFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections =  entity.sections;
      state.gradeLevels = entity.gradeLevels;
      state.teachers =  entity.teachers;
      state.branches = entity.branches;
      state.courses =  entity.courses;
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entities;
    },
    // getSectionAndCourseIds
    sectionAndCourseIdsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sectionAndCourseIds = entities;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleansectionAndCourseIds
    sectionAndCourseIdsCleaned: (state) => {      
      state.sectionAndCourseIds = [];
    },
    // cleanTeacherCoursesState
    coursesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});